import React, {Component} from 'react';
import './Course.css';
import {NavLink} from "react-router-dom";

class TestSubmitResult extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reload: props.reload,
            course: props.course,
            result: props.result,
            resultStored: props.resultStored,
            certificatePostponed: props.certificatePostponed,
            certificateDate: props.certificateDate,
            certificateIssued: props.certificateIssued
        };
    }

    render() {
        const result = typeof this.state.result === 'number' ? Math.round(this.state.result) : this.state.result;
        return <div>
            <p>Wynik testu: <b>{result}%</b></p>
            {this.state.resultStored ?
                <p>Wyniki oraz przebieg {this.state.course.ptype === 't' ? 'testu' : 'quizu'} zostały
                    zapisane.</p> : ''}
            {this.state.certificateIssued ?
                <p>Certyfikat potwierdzający
                    zakończenie {this.state.course.ptype === 't' ? 'kursu' : 'szkolenia'} został prawidłowo
                    wygenerowany.</p> : ''}
            {this.state.certificatePostponed ?
                <p>Certyfikat potwierdzający
                    zakończenie {this.state.course.ptype === 't' ? 'kursu' : 'szkolenia'} zostanie wygenerowany
                    {this.state.certificateDate ? ' w dniu ' + this.state.certificateDate : ' zgodnie z wybraną datą'}.
                </p> : ''}
            <p>
                {this.state.reload ?
                    <NavLink onClick={() => window.location.reload()}
                             to={`/course/${this.state.course.idco}`}>Powrót do
                        początku {this.state.course.ptype === 't' ? 'kursu' : 'szkolenia'}</NavLink>
                    :
                    <NavLink to={`/course/${this.state.course.idco}`}>Powrót do
                        początku {this.state.course.ptype === 't' ? 'kursu' : 'szkolenia'}</NavLink>}
            </p>
        </div>
    }
}

export default TestSubmitResult;